import { useEffect, useState } from "react";
import {fetchMissingData} from "../../../api/sensorApi";
import { toast } from "react-toastify";

function useMissingData({ missingTrue, sensorID }) {
    const [missingData, setMissingData] = useState(null);
    useEffect(() => {
        if (missingTrue) {
            fetchMissingData(sensorID).then((data) => {
                setMissingData(data);
            }).catch((error) => {
                console.error(error);
                toast.error(`Cannot fetch missing features`);
            }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [missingTrue]);

    return { missingData }
}

export default useMissingData;